import { render } from "./AccountSwitcher.vue?vue&type=template&id=5c33c97f&scoped=true&ts=true"
import script from "./AccountSwitcher.vue?vue&type=script&lang=ts"
export * from "./AccountSwitcher.vue?vue&type=script&lang=ts"

import "./AccountSwitcher.vue?vue&type=style&index=0&id=5c33c97f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c33c97f"]])

export default __exports__